import classNames from 'classnames';
import type { FC, ReactNode } from 'react';
import './FormLayout.css';

export interface FormLayoutProps {
  children: ReactNode;
  className?: string;
  /** If form does not end with space reserved for field errors, use this */
  fullFooterSpace?: boolean;
  noPadding?: boolean;
  width?: 'content-default' | 'full';
}

export const FormLayout: FC<FormLayoutProps> = ({
  className,
  fullFooterSpace,
  noPadding,
  width = 'content-default',
  children,
}) => (
  <div
    className={classNames(
      'form-layout',
      noPadding && 'form-layout--no-padding',
      fullFooterSpace && 'form-layout--full-footer-space',
      {
        full: 'w-full',
        'content-default': 'max-w-content-default-legacy',
      }[width],
      className,
    )}
  >
    {children}
  </div>
);
